import './index.scss';
import React, { useEffect, useMemo, useState } from 'react';
import { IPermissionContentProps } from '../../interface';
import { getPermissionList } from '@umu/umu-api';
import { PermissionType } from '../../../../interface';
import { shareOptionMap } from './../../../../dataFlow';
import { getMicroPageInfo } from '../../../../server';
import { If } from 'common/src/components';
import { lang } from '@umu/ukit-lang';
import { PermissionMemberList } from '../../../memberList';
import { Button } from '@umu/umu-design';

const MicroPagePermissionInfo = (props: IPermissionContentProps) => {
    const {
        id,
        prefixCls = 'micro-page-permission-info',
        seId = '',
        showRefresh = false,
        normalizeAccountEPU,
        normalizeAccountName,
    } = props;
    const [dataInfo, setDataInfo] = useState<any>({
        permission: PermissionType.__INIT__,
        microPageInfo: null,
    });
    const [isReload, setIsReload] = useState(false);
    const onInit = (callBack?: () => void) => {
        Promise.all([
            getPermissionList({
                obj_id: id,
                obj_type: 'micro_page',
            }),
            getMicroPageInfo({
                page_id: id,
                se_id: seId,
            }),
        ]).then(([permissionInfo, microPageInfo]) => {
            setDataInfo({
                permission: permissionInfo.selected as PermissionType,
                microPageInfo,
            });
            callBack?.();
        });
    };
    useEffect(() => {
        onInit();
    }, [id]);
    const onRefresh = () => {
        setIsReload(false);
        onInit(() => {
            setIsReload(true);
        });
    };
    const { label, isShowCloseText, isShowAccount, labelSuffix } = useMemo(() => {
        const permission = String(dataInfo.permission) as PermissionType;
        const isDesignAccount = permission === PermissionType.DESIGNATED_ACCOUNT;
        return {
            label: shareOptionMap?.[permission]?.customLabel,
            labelSuffix: showRefresh ? (
                <Button type="text" className="btn-split" isOnlyChildren onClick={onRefresh}>
                    {lang('刷新')}
                </Button>
            ) : (
                ''
            ),
            isShowCloseText: permission === PermissionType.NONE_ALL && !!dataInfo?.microPageInfo?.access_close_tip,
            isShowAccount: isDesignAccount,
        };
    }, [dataInfo.permission]);

    return (
        <div className={prefixCls}>
            <div className={`${prefixCls}-rows-split`}>
                {label}
                {labelSuffix}
            </div>
            <If condition={isShowCloseText}>
                <div className={`${prefixCls}-rows-split`}>{`${lang('关闭提示语：')} ${
                    dataInfo.microPageInfo?.access_close_tip
                }`}</div>
            </If>
            <If condition={isShowAccount}>
                <PermissionMemberList
                    isModeView
                    id={id}
                    isReload={isReload}
                    sourceType={'micro_page'}
                    normalizeAccountEPU={normalizeAccountEPU}
                    normalizeAccountName={normalizeAccountName}
                />
            </If>
        </div>
    );
};
export { MicroPagePermissionInfo };
